import { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { ShopSkeleton } from '@whitesharx/starfall-frontend-core/shop_screen';
import { Coin, ShopProductAPI, PageInfoHeaderSkeleton } from '@whitesharx/starfall-frontend-core';
import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { InfoHeaderSkeleton } from '~/src/components/InfoHeader/InfoHeaderSkeleton';
import { formatCoins, formatProducts } from '../utils/products';
import { pageTitleBlurStyles } from '~/styles/pages/common.css';

export type ShopSkeletonPageProps = {
  purchaseCoins: Coin[];
  avatars: ShopProductAPI[];
  boards: ShopProductAPI[];
  emoticons: ShopProductAPI[];
  phrases: ShopProductAPI[];
};

const ShopSkeletonPage: FC<ShopSkeletonPageProps> = ({ purchaseCoins, avatars, boards, emoticons, phrases }) => (
  <PageLayoutSkeleton rightContainer={<UserInfoSkeleton />}>
    <InfoHeaderSkeleton />
    <PageInfoHeaderSkeleton
      title={t('shop.page-title')}
      name="shop"
      withPlayerCoins
      textClassName={pageTitleBlurStyles}
    />
    <ShopSkeleton
      coins={formatCoins(purchaseCoins)}
      avatars={formatProducts('avatars', avatars)}
      boards={formatProducts('boards', boards)}
      emoticons={formatProducts('emoticons', emoticons)}
      phrases={formatProducts('phrases', phrases)}
    />
  </PageLayoutSkeleton>
);

export default ShopSkeletonPage;
